export { default } from '@features/food-map/Goodbye'
